import React, { useEffect, useState } from "react";
import SubmissionImage from "./Assets/SubmissionImage.png";
import { useSelector, useDispatch } from "react-redux";
import { OpenLoginSignUp } from "../../Actions/ToggleSignupA";
import { FaCheckCircle } from "react-icons/fa"; // Import check icon
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { StepConnector, styled, Typography  } from "@mui/material";
import { FaCheck } from "react-icons/fa"; // Import tick icon
import { GetVLIAgentsA, UpdateVLIAgentsReferrals } from "../../Actions/StudentA";
import { UpdateHeardAboutUsDataA } from "../../Actions/UserA";
import errorMessageImage from "./Assets/errorMessage.png";
import ReuseablePopup from "../../Components/ReuseablePopups/ReuseablePopup";

// Custom Connector
const CustomConnector = styled(StepConnector)(({ theme }) => ({
    "&.MuiStepConnector-root": {
      top: 10, // Adjust vertical alignment
    },
    "& .MuiStepConnector-line": {
      borderColor: "#BEBFED", // Line color
      borderTopWidth: 10, // Line thickness (10px)
      borderRadius: 5, // Smooth edges
    },
  }));
  
  // Custom Step Icon Styling
const CustomStepIcon = styled("div")(({ completed }) => ({
    width: 40,
    height: 40,
    borderRadius: "50%",
    backgroundColor: completed ? "#A1A3EF" : "#BEBFED", // Completed steps use #A1A3EF
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "1.2rem",
    color: "#fff",
    fontWeight: "bold",
  }));

const stepStatuses = ["(Completed)", "(Completed)", "(Completed)", "(Pending)"];

const CustomStepLabel = ({ label, status }) => (
  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
    <Typography
      sx={{
        fontWeight: "bold", // Always bold
        fontSize: { xs: "14px", lg: "17px" },
      }}
    >
      {label}
    </Typography>
    <Typography
      sx={{
        fontSize: { xs: "12px", lg: "14px" },
      }}
    >
      {status}
    </Typography>
  </Box>
);
  
const steps = ["Submission", "Registration Approval", "Payment Received", "Registration Confirmation"];

const CustomStepIconComponent = (props) => {
  const { active, completed, icon } = props;
  return (
    <CustomStepIcon completed={completed}>
      {completed ? <FaCheck size={20} /> : icon} {/* Show tick for completed steps */}
    </CustomStepIcon>
  );
};

const InstituteSubmissionScreen = ({setOpenSignupScreen, InstituteData, instituteId}) => {
    const dispatch = useDispatch();
    const Border = "border-[#E2E2E2] border-[1px] border-solid";
    const { VLIAgentsData } = useSelector((Store) => Store.StudentReducer);
    console.log("VLIAgentsData is:",VLIAgentsData)

    const [selectedMode, setSelectedMode] = useState("");
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [friendDetails, setFriendDetails] = useState({ name: "", email: "" });
    const [selectedReferral, setSelectedReferral] = useState("");
    const [selectedAgent, setSelectedAgent] = useState("");
    const [selectedAgentId, setSelectedAgentId] = useState(null);  // Store the selected agent ID
    const [selectedAgentVLIAssociatePartnerId, setSelectedAgentVLIAssociatePartnerId] = useState('');
    const [isUpdationFailedPopup, setIsUpdationFailedPopup] = useState(false);
    const [errorMessageText, setErrorMessageText] = useState("Something Went Wrong");

    const referralOptions = [
      "Through social media",
      "Through a friend or family member",
      "Online search (Google, Bing, Yahoo)",
      "Associate Member",
    ];
  
    const referralAgents = ["Agent A", "Agent B", "Agent C", "Agent D"]; // Replace with actual agent names
  
    const handleReferralChange = (e) => {
      setSelectedReferral(e.target.value);
      setSelectedAgent(""); // Reset agent selection if the user changes referral
    };

    const handleModeChange = (mode) => {
      setSelectedMode(mode);
      setSelectedOptions([]);
      setFriendDetails({ name: "", email: "" });
      setSelectedAgent("");
    };
  
    const handleCheckboxChange = (option) => {
      setSelectedOptions((prev) =>
        prev.includes(option)
          ? prev.filter((item) => item !== option)
          : [...prev, option]
      );
    };
  

    useEffect(() => {
      dispatch(GetVLIAgentsA())
  }, []); // Empty array means this runs once on component mount

  // Handle the change event for selecting an agent
  const handleAgentChange = (e) => {
    const selectedId = e.target.value;

    // Find the selected agent object using its unique ID
    const selectedAgentData = VLIAgentsData.find(agent => agent.AssociatePartnerId === selectedId);

    if (selectedAgentData) {
        setSelectedAgent(selectedAgentData.AssociatePartnerName);  // Set the agent name
        setSelectedAgentId(selectedId);  // Set the agent ID
        setSelectedAgentVLIAssociatePartnerId(selectedAgentData.VLIAssociatePartnerId); // <-- NEW
        dispatch(UpdateVLIAgentsReferrals(selectedAgentData.AssociatePartnerName,selectedId))
    }
};

const handleSubmit = () => {
  let payload = {
    mode: selectedMode,
  };

  if (selectedMode === "Through social media" || selectedMode === "Through online advertisement") {
    payload.options = selectedOptions; // array of selected platforms
  }

  if (selectedMode === "Through friend or family") {
    payload.friendName = friendDetails.name;
    payload.friendEmail = friendDetails.email;
  }

  if (selectedMode === "Through VLI associate member") {
    payload.associateMemberId = selectedAgentVLIAssociatePartnerId;
  }

  console.log("Payload to send to backend:", payload);

  // Now send to backend
  dispatch(
    UpdateHeardAboutUsDataA(
      payload, // <== send this formatted payload instead of raw userData
      instituteId,
      () => {
        console.log("Institute Registered Successfully!");
        const isLocalhost = window.location.hostname === "localhost";
            window.location.href = isLocalhost
            ? "http://localhost:3000"
            : "https://vehiclelearning.com/"
      },
      (errorMessage) => {
        setErrorMessageText(errorMessage)
        setIsUpdationFailedPopup(true)
      }
    )
  );
};



  return (
  <div className="w-[100%] h-[600px] 2.5xl:h-[800px] 3xl:h-[900px] flex flex-col">
    <div className="w-full flex p-[20px]">
            <div className="w-full lg:w-[60%] flex flex-col lg:p-[30px]">
                <p className="text-[50px] lg:text-[50px] font-bold ">Payment Successful</p>
                <p className="text-[20px]  mt-[20px]">Thank you for choosing Vehicle Learning Innovation.</p>
                <p className="text-[20px]  w-[600px]"> You will be able to login once VLI admin Approve your request, You will be notified within 2 Working days.</p>

                <Box sx={{ width: "100%", mt: 5, ml:{ xs: "-5px", lg: "-40px" }, display: "flex", justifyContent: "start" }}> {/* Center the stepper */}
                  <Stepper activeStep={1} alternativeLabel connector={<CustomConnector />}>
                    {steps.map((label, index) => (
                      <Step key={label} completed={index <= 2}> {/* Mark first step as completed */}
                        <StepLabel StepIconComponent={CustomStepIconComponent}>
                        <CustomStepLabel label={label} isBold={true} status={stepStatuses[index]} />
                        </StepLabel>
                      </Step>
                    ))}
                  </Stepper>
                </Box>

                <p className="text-[20px]  mt-[30px] font-semibold">How Did You Hear About Us</p>

                <div className=" w-[100%] lg:w-[70%] flex flex-col gap-[10px] bg-[#F8FAFA] rounded-[9px] px-[20px] py-[15px] mt-[10px]">
                <div className="mt-[10px] flex flex-col gap-[10px]">
                    {/* <div className="w-full flex flex-col px-[15px] py-[15px] bg-[#FFFFFF] rounded-[8px] shadow-[4px_5px_6px_#00000029] overflow-hidden"
                        style={{border:"1px solid #E8E8E8"}}>
                        <div className="w-full flex items-center justify-between">
                            <div>
                                <input
                                    type="radio"
                                    id="Throughsocialmedia"
                                    name="Throughsocialmedia"
                                    value="Throughsocialmedia"
                                    className="mr-2"
                                />
                                <label htmlFor="paypal" className="text-[18px] text-[#A7A7A7]">
                                  Through social media
                                </label>
                            </div>
                        </div>
                        {selectedPaymentMethod === "Throughsocialmedia" && (
                            <div className="mt-[10px] flex flex-col gap-[10px]">
                                <div className="flex gap-[10px] items-center ">
                                    <input
                                        type="Checkbox"
                                        placeholder="Email Address"
                                        
                                        className={`w-[20px] h-[20px]`}
                                    />
                                    <p className="text-[18px] text-[#625BA8]"></p>
                                </div>
                                <div className="flex gap-[10px] items-center ">
                                    <input
                                        type="Checkbox"
                                        placeholder="Email Address"
                                        
                                        className={`w-[20px] h-[20px]`}
                                    />
                                    <p className="text-[18px] text-[#625BA8]"></p>
                                </div>
                                <div className="flex gap-[10px] items-center ">
                                    <input
                                        type="Checkbox"
                                        placeholder="Email Address"
                                        
                                        className={`w-[20px] h-[20px]`}
                                    />
                                    <p className="text-[18px] text-[#625BA8]">Facebook</p>
                                </div>
                                <div className="flex gap-[10px] items-center ">
                                    <input
                                        type="Checkbox"
                                        placeholder="Email Address"
                                        
                                        className={`w-[20px] h-[20px]`}
                                    />
                                    <p className="text-[18px] text-[#625BA8]">TikTok</p>
                                </div>
                                <div className="flex gap-[10px] items-center ">
                                    <input
                                        type="Checkbox"
                                        placeholder="Email Address"
                                        
                                        className={`w-[20px] h-[20px]`}
                                    />
                                    <p className="text-[18px] text-[#625BA8]">Instagram</p>
                                </div>
                            </div>
                        )}
                    </div> */}

                      {/* 1. Through Social Media */}
                    <div className="w-full flex flex-col px-[15px] py-[15px] bg-white rounded-[8px] shadow-[4px_5px_6px_#00000029] overflow-hidden" style={{ border: "1px solid #E8E8E8" }}>
                      <div className="w-full flex items-center justify-between">
                        <div>
                          <input
                            type="radio"
                            id="socialMedia"
                            name="leadSource"
                            value="Through social media"
                            checked={selectedMode === "Through social media"}
                            onChange={() => handleModeChange("Through social media")}
                            className="mr-2"
                          />
                          <label htmlFor="socialMedia" className="text-[18px] text-[#A7A7A7]">
                            Through social media
                          </label>
                        </div>
                      </div>

                      {selectedMode === "Through social media" && (
                        <div className="mt-[10px] flex flex-col gap-[10px] ml-[40px]">
                          {["Facebook", "TikTok", "Instagram"].map((platform) => (
                            <div key={platform} className="flex gap-[10px] items-center">
                              <input
                                type="checkbox"
                                checked={selectedOptions.includes(platform)}
                                onChange={() => handleCheckboxChange(platform)}
                                className="w-[15px] h-[15px]"
                              />
                              <p className="text-[18px] text-[#625BA8]">{platform}</p>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    {/* 2. Through Friend or Family */}
                    <div className="w-full flex flex-col px-[15px] py-[15px] bg-white rounded-[8px] shadow-[4px_5px_6px_#00000029]" style={{ border: "1px solid #E8E8E8" }}>
                      <div className="w-full flex items-center justify-between">
                        <div>
                          <input
                            type="radio"
                            id="friendFamily"
                            name="leadSource"
                            value="Through friend or family"
                            checked={selectedMode === "Through friend or family"}
                            onChange={() => handleModeChange("Through friend or family")}
                            className="mr-2"
                          />
                          <label htmlFor="friendFamily" className="text-[18px] text-[#A7A7A7]">
                            Through friend or family
                          </label>
                        </div>
                      </div>

                      {selectedMode === "Through friend or family" && (
                        <div className="mt-[10px] flex flex-col gap-[10px]">
                          <input
                            type="text"
                            placeholder="Name"
                            value={friendDetails.name}
                            onChange={(e) => setFriendDetails({ ...friendDetails, name: e.target.value })}
                            className={`w-full rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                          />
                          <input
                            type="email"
                            placeholder="Email"
                            value={friendDetails.email}
                            onChange={(e) => setFriendDetails({ ...friendDetails, email: e.target.value })}
                            className={`w-full rounded-md text-[18px] py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] `}
                          />
                        </div>
                      )}
                    </div>

                    {/* 3. Online Advertisement */}
                    <div className="w-full flex flex-col px-[15px] py-[15px] bg-white rounded-[8px] shadow-[4px_5px_6px_#00000029]" style={{ border: "1px solid #E8E8E8" }}>
                      <div className="w-full flex items-center justify-between">
                        <div>
                          <input
                            type="radio"
                            id="onlineAds"
                            name="leadSource"
                            value="Through online advertisement"
                            checked={selectedMode === "Through online advertisement"}
                            onChange={() => handleModeChange("Through online advertisement")}
                            className="mr-2"
                          />
                          <label htmlFor="onlineAds" className="text-[18px] text-[#A7A7A7]">
                            Through online advertisement
                          </label>
                        </div>
                      </div>

                      {selectedMode === "Through online advertisement" && (
                        <div className="mt-[10px] flex flex-col gap-[10px] ml-[40px]">
                          {["YouTube", "Brochure/Flyer", "Commercial Advertisement", "Digital Media"].map((platform) => (
                            <div key={platform} className="flex gap-[10px] items-center">
                              <input
                                type="checkbox"
                                checked={selectedOptions.includes(platform)}
                                onChange={() => handleCheckboxChange(platform)}
                                className="w-[15px] h-[15px]"
                              />
                              <p className="text-[18px] text-[#625BA8]">{platform}</p>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                  {/* 4. Through VLI Associate Member */}
                  <div className="w-full flex flex-col px-[15px] py-[15px] bg-white rounded-[8px] shadow-[4px_5px_6px_#00000029]" style={{ border: "1px solid #E8E8E8" }}>
                    <div className="w-full flex items-center justify-between">
                      <div>
                        <input
                          type="radio"
                          id="vliAssociate"
                          name="leadSource"
                          value="Through VLI associate member"
                          checked={selectedMode === "Through VLI associate member"}
                          onChange={() => handleModeChange("Through VLI associate member")}
                          className="mr-2"
                        />
                        <label htmlFor="vliAssociate" className="text-[18px] text-[#A7A7A7]">
                          Through VLI associate member
                        </label>
                      </div>
                    </div>

                    {selectedMode === "Through VLI associate member" && (
                      <div className="mt-[10px] flex flex-col gap-[10px]">
                      <select
                        id="referralAgent"
                        name="referralAgent"
                        className={`w-full lg:full mt-[20px] rounded-md py-2 px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] text-[#000000]`}
                        value={selectedAgentId}
                        onChange={handleAgentChange}
                      >
                        <option value="">Select Associate Member</option>
                          {VLIAgentsData?.map((agent) => (
                              <option key={agent.AssociatePartnerId} value={agent.AssociatePartnerId}>
                                  {agent.AssociatePartnerName} ({agent.AssociatePartnerId})
                              </option>
                          ))}
                      </select>
                      </div>
                    )}
                  </div>     
                </div>
            </div>

                {/* Referral Select */}
                {/* <select
                    id="referralSource"
                    name="referralSource"
                    className={`w-full lg:w-[50%] mt-[15px] rounded-md py-2 px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] text-[#000000]`}
                    value={selectedReferral}
                    onChange={handleReferralChange}
                  >
                    <option value="">Select Option</option>
                    {referralOptions.map((option, index) => (
                      <option key={index} value={option}>
                        {option}
                      </option>
                    ))}
                </select> */}

                {/* Conditional Referral Agent Select */}
                {/* {selectedReferral === "Associate Member" && (
                  <select
                    id="referralAgent"
                    name="referralAgent"
                    className={`w-full lg:w-[50%] mt-[20px] rounded-md py-2 px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] text-[#000000]`}
                    value={selectedAgentId}
                    onChange={handleAgentChange}
                  >
                    <option value="">Select Associate Member</option>
                      {VLIAgentsData?.map((agent) => (
                          <option key={agent.AssociatePartnerId} value={agent.AssociatePartnerId}>
                              {agent.AssociatePartnerName} ({agent.AssociatePartnerId})
                          </option>
                      ))}
                  </select>
                )}  */}
            </div>

            <div className="hidden lg:flex w-[40%]">
                <img src={SubmissionImage} alt="SubmissionImage" className="w-[130%] ml-[-150px] mt-[-40px] h-[]" />
            </div>
    </div>

    <div className="w-full flex justify-center lg:justify-center gap-[20px] mt-[40px] lg:mt-[-40px] pb-[50px] lg:pb-[50px]">
        <button
            className={`w-[130px] lg:w-[150px] text-[#FFFFFF] cursor-pointer rounded-[8px]  py-2
                    text-[16px] bg-[#625BA8]  xl:py-[10px]
                        xl:text-[18px]     2xl:text-base`}
                        onClick={handleSubmit}
          >
            Submit
        </button>
    </div>

    {isUpdationFailedPopup && (
        <ReuseablePopup
        setShowPopup={setIsUpdationFailedPopup}
        heading="Oops!"
        text={errorMessageText}
        btnText="Back"
        onClick={() => setIsUpdationFailedPopup(false)} // <-- Add this line
        imageSrc={errorMessageImage} // ✅ Dynamic image source
        />
    )}

  </div>
  );
}

export default InstituteSubmissionScreen;
